import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/cashWheel',
    alias: ['/cash-wheel', '/cash-wheel.html'],
    name: 'cashWheel',
    component: () => import('../views/CashWheel.vue')
  },
  {
    path: '/code',
    name: 'code',
    component: () => import('../views/code.vue')
  },
  {
    path: '/inviteDetail',
    alias: '/invite-detail',
    name: 'inviteDetail',
    component: () => import('../views/InviteDetail.vue')
  },
  {
    path: '/tacitGame',
    alias: '/tacit-game',
    name: 'tacitGame',
    component: () => import('../views/TacitGame.vue')
  },
  {
    path: '/HappyNewYear',
    name: 'HappyNewYear',
    component: () => import('../views/HappyNewYear.vue')
  },{
    path: '/summerActive',
    name: 'summerActive',
    component: () => import('../views/summerActive.vue')
  }
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
